import { render, staticRenderFns } from "./secBanner.vue?vue&type=template&id=ad5748dc&scoped=true&"
import script from "./secBanner.vue?vue&type=script&lang=js&"
export * from "./secBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5748dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad5748dc')) {
      api.createRecord('ad5748dc', component.options)
    } else {
      api.reload('ad5748dc', component.options)
    }
    module.hot.accept("./secBanner.vue?vue&type=template&id=ad5748dc&scoped=true&", function () {
      api.rerender('ad5748dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/bike/child/secBanner.vue"
export default component.exports